import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aecc25f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "person" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "person__content" }
const _hoisted_5 = { class: "person__quote" }
const _hoisted_6 = { class: "person__name" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))


const __default__ = {
  name: 'PeopleComponent',
};

import { ref } from 'vue';
import { gsap } from 'gsap';
import { useStore } from '@/store';

interface GsapObjectValue {
  top?: number;
  bottom?: number;
  left?: string | number;
  right?: string | number;
  transformOrigin: string;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();
const { posts } = store.state.posts;
const viewRef = ref<HTMLElement>();
const currentTriggerRef = ref<HTMLButtonElement>();
const activeSlug = ref('');
const ITEM_SIZE = 3;

const onExpand = async (item: HTMLElement, content: HTMLElement) => {
  if (!viewRef.value) return;
  const w = window.innerWidth;
  const viewTop = Math.round(viewRef.value.getBoundingClientRect().top + window.scrollY);
  const itemTop = Math.round(item.getBoundingClientRect().top + window.scrollY);
  const itemHeight = item.clientHeight / ITEM_SIZE;
  const itemLeft = Math.round(item.getBoundingClientRect().left);
  const itemExpandedLeft = itemLeft + item.clientWidth;
  const itemExpandedTop = Math.round(itemTop - item.clientHeight + itemHeight);

  let obj: GsapObjectValue = { top: 0, left: 0, transformOrigin: 'top left' };

  if (viewTop === itemTop) {
    if (itemExpandedLeft > w) {
      obj = { top: 0, right: 0, transformOrigin: 'top right' };
    } else {
      obj = { top: 0, left: 0, transformOrigin: 'top left' };
    }
  } else if (itemExpandedLeft > w) {
    if (viewTop > itemExpandedTop) {
      obj = { top: 0, right: 0, transformOrigin: 'top right' };
    } else {
      obj = { bottom: 0, right: 0, transformOrigin: 'bottom right' };
    }
  } else if (viewTop > itemExpandedTop) {
    obj = { top: 0, left: 0, transformOrigin: 'top left' };
  } else {
    obj = { bottom: 0, left: 0, transformOrigin: 'bottom left' };
  }

  console.log({
    viewTop,
    itemExpandedLeft,
    w,
    itemHeight: Math.ceil(itemHeight),
    top: viewTop + Math.ceil(itemHeight),
    itemTop,
    itemExpandedTop
  });

  if (viewTop + Math.ceil(itemHeight) === itemTop) {
    obj.top = 0;
    obj.bottom = 0;
    obj.transformOrigin = itemExpandedLeft >= w ? 'center right' : 'center left';
  }

  item.classList.add('is-active');
  gsap.set(item, obj);
  await gsap.to(item, {
    scale: 1,
  });

  gsap.to(content, {
    opacity: 1,
  });
};

const onShrink = async (item: HTMLElement, content: HTMLElement) => {
  await gsap.to(content, { opacity: 0, ease: 'power2.out', duration: 0.4 });
  await gsap.to(item, { scale: 1 / ITEM_SIZE, ease: 'power2.out', duration: 0.4 });
  item.classList.remove('is-active');
};

const handlePersonClick = async (event: MouseEvent, slug: string) => {
  if (!slug) return;
  const element = event.currentTarget as HTMLButtonElement;
  const item = element.parentElement as HTMLElement;
  const content = element.nextSibling as HTMLElement;

  if (currentTriggerRef.value) {
    const currentItem = currentTriggerRef.value.parentElement as HTMLElement;
    const currentContent = currentTriggerRef.value.nextSibling as HTMLElement;
    await onShrink(currentItem, currentContent);
  }

  if (activeSlug.value === slug) {
    onShrink(item, content);
    currentTriggerRef.value = undefined;
    activeSlug.value = '';
  } else {
    onExpand(item, content);
    currentTriggerRef.value = element;
    activeSlug.value = slug;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "people",
    ref_key: "viewRef",
    ref: viewRef,
    "data-cursor": "small"
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(posts), (person) => {
      return (_openBlock(), _createElementBlock("div", {
        key: person.frontmatter.name,
        class: "people__item"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            src: person.frontmatter.image,
            alt: `voice of ${person.frontmatter.name}`,
            class: "person__image",
            loading: "lazy"
          }, null, 8, _hoisted_2),
          _createElementVNode("button", {
            class: "person__trigger",
            onClick: (event) => handlePersonClick(event, person.slug)
          }, _toDisplayString(person.frontmatter.name), 9, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h4", _hoisted_5, _toDisplayString(person.frontmatter.quote), 1),
            _createElementVNode("p", null, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(person.frontmatter.name), 1),
              _hoisted_7,
              _createElementVNode("span", null, _toDisplayString(person.frontmatter.job), 1)
            ])
          ])
        ])
      ]))
    }), 128))
  ], 512))
}
}

})